//*** new file: src/components/OfflineBanner.jsx ***
import React, { useEffect, useState } from 'react';

export default function OfflineBanner() {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      background: '#ffcc00',
      color: '#000',
      padding: '8px 12px',
      textAlign: 'center',
      zIndex: 9999,
      fontWeight: 600
    }}>
      Ти офлайн — деякі дані можуть бути неактуальні.
    </div>
  );
}
